interface ContactInfo {
  company: {
    name: {
      en: string;
      zh: string;
    };
    address: {
      en: string;
      zh: string;
    };
    phone: string;
    email: string;
  };
  whatsapp: {
    number: string;
    message: {
      en: string;
      zh: string;
    };
  };
}

export const contactInfo: ContactInfo = {
  company: {
    name: {
      en: "GamiFly Tech",
      zh: "天遊創意科技",
    },
    address: {
      en: "Tsuen Wan, Castle Peak Rd - Tsuen Wan, 459-469, Floor 11, Room A-B Wah Lik Industrial Centre",
      zh: "新界荃灣青山公路荃灣段, 459-469號華力工業中心, 11樓A-B室",
    },
    phone: "+852 5406 4754",
    email: "gamiflytech@gmail.com",
  },
  whatsapp: {
    number: "85254064754",
    message: {
      en: "Hello, I'm interested in your services. Can you help me?",
      zh: "您好，我對您的服務感興趣。您能幫助我嗎？",
    },
  },
};

export default contactInfo; 